export const clickableStyle: any = {
  "&:hover": {
    cursor: "pointer",
  },
};

export const ellipsisStyle: any = {
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
};

export const markedForDeletionStyle = (theme) => ({
  position: "relative",
  pointerEvents: "none",
  opacity: 0.5,
  "&::after": {
    display: "flex",
    position: "absolute",
    content: `"Deleting"`,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    //backgroundColor: "#ffb0b085",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    opacity: 1,
    fontSize: "1.4em",
    color: theme.palette.error.main,
  },
});

export const clearfixStyle: any = {
  clear: "both",

  "&::after": {
    content: "",
    display: "table",
    clear: "both",
  },
};
